// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2744":"5d8aae4b","4915":"5d8aae4b","7588":"e01e6cbc","8263":"5d8aae4b"}[chunkId] + ".chunk.css";
};